import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: {
      title: "登录 - 百运网供应商中心",
    },
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  //一级菜单
  {
    path: "/",
    component: Layout,
    redirect: "/homePage",
    children: [
      {
        path: "homePage",
        name: "HomePage",
        component: () => import("@/views/homePage/index.vue"),
        meta: {
          title: "首页",
          icon: "dashboard",
          affix: true,
          breadcrumbList: [
            {
              url: "",
              name: "首页",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/invite",
    component: Layout,
    redirect: "/invite/cooperation",
    children: [
      {
        path: "cooperation",
        name: "invitecooperation",
        icon: "table",
        component: () => import("@/views/inviteCooperation/index.vue"),
        // meta: {
        //   title: "邀请合作",
        //   icon: "table",
        // },
      },
    ],
  },

  {
    path: "/baseInfo",
    component: Layout,
    redirect: "/baseInfo",
    children: [
      {
        path: "baseInfo",
        name: "baseInfo",
        component: () => import("@/views/baseInfo/index.vue"),
        meta: {
          title: "用户中心",
          icon: "table",
          breadcrumbList: [
            // {
            //   url: "",
            //   name: "资金管理",
            // },
            {
              url: "/baseInfo",
              name: "用户中心",
            },
          ],
        },
      },
    ],
  },
  // {
  //   path: '/example',
  //   component: Layout,
  //   redirect: '/example/table',
  //   name: 'Example',

  //   meta: { title: '基本信息', icon: 'el-icon-s-help' },
  //   children: [
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: '基本资料' }
  //     },
  //     {
  //       path: 'tree',
  //       name: 'Tree',
  //       component: () => import('@/views/tree/index'),
  //       meta: { title: '企业认证' }
  //     },
  //   ]
  // },
  //二级菜单
  {
    path: "/orderManagement",
    component: Layout,
    redirect: "/orderManagement/exp",
    name: "Example",
    meta: { title: "订单管理", icon: "el-icon-s-help" },
    children: [
      {
        path: "exp",
        name: "EXP",
        component: () => import("@/views/exp/index"),
        meta: {
          title: "快递/专线订单",
          icon: "table",
          keepAlive: true,
          breadcrumbList: [
            // {
            //   url: "",
            //   name: "资金管理",
            // },
            {
              url: "/orderManagement/exp",
              name: "快递/专线订单",
            },
          ],
        },
      },
      {
        path: "exp-Detail",
        name: "exp-Detail",
        component: () => import("@/views/exp/components/detail"),
        meta: {
          //keepAlive:true,
          title: "快递订单详情",
          // title: (params) => {
          //   console.log("地址栏===", params);
          //   if (params.id) {
          //     return "查看" + params.id;
          //   } else {
          //     return "快递订单详情";
          //   }
          // },
          breadcrumbList: [
            {
              url: "/orderManagement/exp",
              name: "快递订单",
            },
            {
              url: "/orderManagement/exp-Detail",
              name: "快递订单详情",
            },
          ],
        },
        hidden: true,
      },
      {
        path: "fba",
        name: "FBA",
        component: () => import("@/views/fba/index"),
        meta: {
          title: "FBA订单",
          icon: "table",
          keepAlive: true,
          breadcrumbList: [
            {
              url: "/orderManagement/fba",
              name: "FBA订单",
            },
          ],
        },
      },
      {
        path: "fba-Detail",
        name: "fba-Detail",
        component: () => import("@/views/fba/components/detail"),
        meta: {
          title: "FBA订单详情",
          // title: (params) => {
          //   console.log("地址栏===", params);
          //   if (params.id) {
          //     return "查看" + params.id;
          //   } else {
          //     return "FBA订单详情";
          //   }
          // },
          breadcrumbList: [
            {
              url: "/orderManagement/fba",
              name: "FBA订单",
            },
            {
              url: "/orderManagement/fba-Detail",
              name: "FBA订单详情",
            },
          ],
        },
        hidden: true,
      },
      // 空运订单
      {
        path: "air",
        name: "air",
        component: () => import("@/views/orderManagement/air/orderList.vue"),
        meta: {
          title: "空运订单",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/air",
              name: "空运订单",
            },
          ],
        },
      },
      {
        path: "airDetail",
        name: "airDetail",
        component: () => import("@/views/orderManagement/air/orderDetail.vue"),
        meta: {
          title: "空运订单详情",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/air",
              name: "空运订单",
            },
            {
              url: "/orderManagement/airDetail",
              name: "空运订单详情",
            },
          ],
        },
        hidden: true,
      },
      // 空运询盘订单
      {
        path: "inquiry",
        name: "inquiry",
        component: () =>
          import("@/views/orderManagement/inquiry/orderList.vue"),
        meta: {
          title: "询盘订单",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/inquiry",
              name: "询盘订单",
            },

          ],
        },
      },
      {
        path: "inquiryDetail",
        name: "inquiryDetail",
        component: () =>
          import("@/views/orderManagement/inquiry/orderDetail.vue"),
        meta: {
          title: "询盘详情",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/inquiry",
              name: "询盘订单",
            },
            {
              url: "/orderManagement/inquiryDetail",
              name: "询盘详情",
            },
          ],
        },
        hidden: true,
      },
      {
        // 报价详情
        path: "offerDetail",
        name: "offerDetail",
        component: () =>
          import("@/views/orderManagement/inquiry/offerDetail.vue"),
        meta: {
          title: "报价详情",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/inquiry",
              name: "询盘订单",
            },
            {
              url: "/orderManagement/offerDetail",
              name: "报价详情",
            },
          ],
        },
        hidden: true,
      },
      {
        // 立即报价
        path: "offerNow",
        name: "offerNow",
        component: () => import("@/views/orderManagement/inquiry/offerNow.vue"),
        meta: {
          title: "立即报价",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/inquiry",
              name: "询盘订单",
            },
            {
              url: "/orderManagement/offerNow",
              name: "立即报价",
            },
          ],
        },
        hidden: true,
      },
      // 取件订单
      {
        path: "pickup",
        name: "pickup",
        component: () => import("@/views/orderManagement/pickup/orderList.vue"),
        meta: {
          title: "取件订单",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/pickup",
              name: "取件订单",
            },
          ],
        },
      },
      {
        path: "pickupDetail",
        name: "pickupDetail",
        component: () =>
          import("@/views/orderManagement/pickup/orderDetail.vue"),
        meta: {
          title: "取件订单详情",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/orderManagement/pickup",
              name: "取件订单",
            },
            {
              url: "/orderManagement/pickupDetail",
              name: "取件订单详情",
            },
          ],
        },
        hidden: true,
      },
    ],
  },

  {
    path: "/fund",
    component: Layout,
    redirect: "/fund/accountLimit",
    name: "Example",
    meta: { title: "资金管理", icon: "el-icon-s-help" },
    children: [
      {
        path: "bill",
        name: "bill",
        component: () => import("@/views/fundManagement/bill/list/index"),
        meta: {
          title: "账单查询",
          icon: "table",
          breadcrumbList: [
            // {
            //   url: "",
            //   name: "资金管理",
            // },
            {
              url: "/fund/bill",
              name: "账单查询",
            },
          ],
        },
      },
      {
        path: "accountLimit",
        name: "accountLimit",
        component: () =>
          import("@/views/fundManagement/accountLimit/list/index"),
        meta: {
          title: "账户额度信息",
          icon: "table",
          breadcrumbList: [
            // {
            //   url: "",
            //   name: "FBA操作",
            // },
            {
              url: "/fund/accountLimit",
              name: "账户额度信息",
            },
          ],
        },
      },
      {
        path: "cashout",
        name: "cashout",
        component: () => import("@/views/fundManagement/cashout/list/index"),
        meta: {
          title: "提现管理",
          icon: "table",
          breadcrumbList: [
            // {
            //   url: "",
            //   name: "FBA操作",
            // },
            {
              url: "/fund/cashout",
              name: "提现管理",
            },
          ],
        },
      },
    ],
  },

  //三级菜单
  {
    path: "/warehouse",
    component: Layout,
    redirect: "/warehouse/exp/receipt",
    //name: 'warehouse',
    meta: {
      title: "仓库管理",
      icon: "nested",
    },
    children: [
      {
        path: "exp",
        component: () => import("@/views/warehouse/exp/index"), // Parent router-view
        // component: Layout,
        redirect: "/warehouse/exp/receipt",
        meta: { title: "快递操作" },
        children: [
          {
            path: "receipt",
            component: () => import("@/views/warehouse/exp/receipt"),
            name: "receipt",
            meta: {
              title: "快递收货管理",
              keepAlive: true,
              breadcrumbList: [
                {
                  url: "",
                  name: "快递操作",
                },
                {
                  url: "/warehouse/exp/receipt",
                  name: "快递收货管理",
                },
              ],
            },
          },

          {
            path: "shipment",
            component: () => import("@/views/warehouse/exp/shipment"),
            name: "receipt",
            meta: {
              title: "快递发货管理",
              keepAlive: true,
              breadcrumbList: [
                {
                  name: "快递操作",
                },
                {
                  url: "/warehouse/exp/shipment",
                  name: "快递发货管理",
                },
              ],
            },
          },
        ],
      },
      {
        path: "fba",
        component: () => import("@/views/warehouse/fba/index"), // Parent router-view
        //name: 'warehouse-fba',
        redirect: "/warehouse/fba/receipt",
        meta: { title: "FBA操作" },
        children: [
          {
            path: "receipt",
            component: () => import("@/views/warehouse/fba/receipt"),
            name: "receipt",
            meta: {
              title: "FBA收货管理",
              keepAlive: true,
              breadcrumbList: [
                {
                  url: "",
                  name: "FBA操作",
                },
                {
                  url: "/warehouse/fba/receipt",
                  name: "FBA收货管理",
                },
              ],
            },
          },

          {
            path: "shipment",
            component: () => import("@/views/warehouse/fba/shipment"),
            name: "shipment",
            meta: {
              title: "FBA发货管理",
              keepAlive: true,
              breadcrumbList: [
                {
                  url: "",
                  name: "FBA操作",
                },
                {
                  url: "/warehouse/fba/shipment",
                  name: "FBA发货管理",
                },
              ],
            },
          },
        ],
      },
    ],
  },
  // 基础信息维护
  {
    path: "/basicData",
    component: Layout,
    redirect: "/basicData/pickupDriver",
    name: "basicData",
    meta: { title: "基础数据维护", icon: "el-icon-s-help" },
    children: [
      // 取件司机
      {
        path: "pickupDriver",
        name: "pickupDriver",
        component: () => import("@/views/basicData/pickupDriver.vue"),
        meta: {
          title: "取件司机",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/basicData/pickupDriver",
              name: "取件司机",
            },
          ],
        },
      },
      // 渠道对应关系
      {
        path: "channelCorrespondence",
        name: "channelCorrespondence",
        component: () => import("@/views/basicData/channelCorrespondence.vue"),
        meta: {
          title: "渠道对应关系",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/basicData/channelCorrespondence",
              name: "渠道对应关系",
            },
          ],
        },
      },
      //仓库管理
      {
        path: "storesControl",
        name: "storesControl",
        component: () => import("@/views/basicData/storesControl.vue"),
        meta: {
          title: "仓库管理",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/basicData/storesControl",
              name: "仓库管理",
            },
          ],
        },
      },
    ],
  },
  // 渠道管理
  {
    path: "/channelManagement",
    component: Layout,
    redirect: "/channelManagement/airChannelList",
    name: "channelManagement",
    meta: { title: "渠道管理", icon: "el-icon-s-help" },
    children: [

      {
        path: "exp",
        name: "exp",
        component: () => import("@/views/channelManagement/exp/index.vue"),
        meta: {
          title: "快递渠道",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/exp",
              name: "快递渠道",
            },
          ],
        },
      },
      {
        path: "addEdit",
        name: "addEdit",
        component: () => import("@/views/channelManagement/exp/expEdit.vue"),
        meta: {
          title: "新增快递渠道",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/exp",
              name: "快递渠道",
            },
            {
              url: "/channelManagement/addEdit",
              name: "新增快递渠道",
            },
          ],
        },
        hidden: true,
      },
      {
        path: "expEdit",
        name: "expEdit",
        component: () =>
          import("@/views/channelManagement/exp/SetOf/index.vue"),
        meta: {
          title: "快递渠道编辑",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/exp",
              name: "快递渠道",
            },
            {
              url: "/channelManagement/expEdit",
              name: "快递渠道编辑",
            },
          ],
        },
        hidden: true,
      },
      //快递渠道
      {
        path: "expCheckPrice",
        name: "expCheckPrice",
        component: () => import("@/views/checkPrice/exp/index.vue"),
        meta: {
          title: "快递查价",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/expCheckPrice",
              name: "快递查价",
            },
          ],
        },
      },
      //Fba渠道
      {
        path: "fba",
        name: "fab",
        component: () => import("@/views/channelManagement/fba/index.vue"),
        meta: {
          title: "FBA渠道",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/fba",
              name: "FBA渠道",
            },
          ],
        },
      },
      {
        path: "addEditFBA",
        name: "addEditFBA",
        component: () => import("@/views/channelManagement/fba/fbaEdit.vue"),
        meta: {
          title: "新增FBA渠道",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/fba",
              name: "FBA渠道",
            },
            {
              url: "/channelManagement/addEditFBA",
              name: "新增FBA渠道",
            },
          ],
        },
        hidden: true,
      },
      {
        path: "fbaEdit",
        name: "fbaEdit",
        component: () =>
          import("@/views/channelManagement/fba/SetOf/index.vue"),
        meta: {
          title: "FBA渠道编辑",
          icon: "table",
          breadcrumbList: [
            {
              url: "/channelManagement/fba",
              name: "FBA渠道",
            },
            {
              url: "/channelManagement/fbaEdit",
              name: "FBA渠道编辑",
            },
          ],
        },
        hidden: true,
      },
      // fba查价
      {
        path: "fbaCheckPrice",
        name: "fbaCheckPrice",
        component: () =>
          import("@/views/checkPrice/fba/index.vue"),
        meta: {
          title: "FBA渠道查价",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/fbaCheckPrice",
              name: "FBA查价",
            },
          ],
        },
      },
      // 空运渠道
      {
        path: "airChannelList",
        name: "airChannelList",
        component: () =>
          import("@/views/channelManagement/air/channelList.vue"),
        meta: {
          title: "空运渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/airChannelList",
              name: "空运渠道",
            },
          ],
        },
      },
      {
        path: "addAirChannel",
        name: "addAirChannel",
        component: () => import("@/views/channelManagement/air/addChannel.vue"),
        meta: {
          title: "新增空运渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/airChannelList",
              name: "空运渠道",
            },
            {
              url: "/channelManagement/addAirChannel",
              name: "新增空运渠道",
            },
          ],
        },
        hidden: true,
      },
      {
        path: "editAirChannel",
        name: "editAirChannel",
        component: () =>
          import("@/views/channelManagement/air/editChannel.vue"),
        meta: {
          title: "编辑空运渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/airChannelList",
              name: "空运渠道",
            },
            {
              url: "/channelManagement/editAirChannel",
              name: "编辑空运渠道",
            },
          ],
        },
        hidden: true,
      },
      // 取件渠道
      {
        path: "pickupChannelList",
        name: "pickupChannelList",
        component: () =>
          import("@/views/channelManagement/pickup/channelList.vue"),
        meta: {
          title: "取件渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/pickupChannelList",
              name: "取件渠道",
            },
          ],
        },
      },
      {
        path: "addPickupChannel",
        name: "addPickupChannel",
        component: () =>
          import("@/views/channelManagement/pickup/addChannel.vue"),
        meta: {
          title: "新增取件渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/pickupChannelList",
              name: "取件渠道",
            },
            {
              url: "/channelManagement/addPickupChannel",
              name: "新增取件渠道",
            },
          ],
        },
        hidden: true,
      },
      {
        path: "editPickupChannel",
        name: "editPickupChannel",
        component: () =>
          import("@/views/channelManagement/pickup/editChannel.vue"),
        meta: {
          title: "编辑取件渠道",
          icon: "table",
          keepAlive: false,
          breadcrumbList: [
            {
              url: "/channelManagement/pickupChannelList",
              name: "取件渠道",
            },
            {
              url: "/channelManagement/editPickupChannel",
              name: "编辑取件渠道",
            },
          ],
        },
        hidden: true,
      },
    ],
  },
  // 操作管理
  {
    path: "/operationManagement",
    component: Layout,
    redirect: "/operationManagement/air",
    name: "operationManagement",
    meta: { title: "操作管理", icon: "el-icon-s-help" },
    children: [
      // 空运渠道
      {
        path: "air",
        name: "air",
        component: () =>
          import("@/views/operationManagement/air/orderList.vue"),
        meta: {
          title: "空运操作列表",
          icon: "table",
          keepAlive: true,
          breadcrumbList: [
            {
              url: "/operationManagement/air",
              name: "空运操作列表",
            },
          ],
        },
      },
      {
        path: "airDetail",
        name: "airDetail",
        component: () =>
          import("@/views/operationManagement/air/orderDetail.vue"),
        meta: {
          title: "空运操作详情",
          icon: "table",
          keepAlive: true,
          breadcrumbList: [
            {
              url: "/operationManagement/air",
              name: "空运操作列表",
            },
            {
              url: "/orderManagement/airDetail",
              name: "空运操作详情",
            },
          ],
        },
        hidden: true,
      },
    ],
  },
  //个人中心

  {
    path: "/personalCenter",
    component: Layout,
    redirect: "/personalCenter/certification",
    name: "personalCenter",
    meta: { title: "个人中心", icon: "el-icon-s-help" },
    children: [
      //认证
      {
        path: "certification",
        name: "certification",
        component: () =>
          import("@/views/personalCenter/certification/notCertified.vue"),
        meta: {
          title: "实名认证、入驻资质申请",
          icon: "table",
          breadcrumbList: [
            {
              url: "/personalCenter/certification",
              name: "实名认证、入驻资质申请",
            },
          ],
        },
      },
    ],
  },

  // {
  //   path: '/form',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Form',
  //       component: () => import('@/views/form/index'),
  //       meta: { title: 'Form', icon: 'form' }
  //     }
  //   ]
  // },
  //三级菜单
  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: 'Nested',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [
  //         {
  //           path: 'menu1-1',
  //           component: () => import('@/views/nested/menu1/menu1-1'),
  //           name: 'Menu1-1',
  //           meta: { title: 'Menu1-1' }
  //         },
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             },
  //             {
  //               path: 'menu1-2-2',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-2'),
  //               name: 'Menu1-2-2',
  //               meta: { title: 'Menu1-2-2' }
  //             }
  //           ]
  //         },
  //         {
  //           path: 'menu1-3',
  //           component: () => import('@/views/nested/menu1/menu1-3'),
  //           name: 'Menu1-3',
  //           meta: { title: 'Menu1-3' }
  //         }
  //       ]
  //     },
  //     {
  //       path: 'menu2',
  //       component: () => import('@/views/nested/menu2/index'),
  //       name: 'Menu2',
  //       meta: { title: 'menu2' }
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
